import { View } from 'react-native'

// Stub for libraries (e.g. react-native-safe-area-context) that import RN codegen on web.
// biome-ignore lint/style/noDefaultExport: shim must mirror react-native codegenNativeComponent default export.
export default function codegenNativeComponent(_name: string) {
  return View
}
